import { render } from "./doctor-signup.vue?vue&type=template&id=0329d2d6"
import script from "./doctor-signup.vue?vue&type=script&lang=js"
export * from "./doctor-signup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__